import script from "./confirm-error.vue?vue&type=script&lang=ts&setup=true"
export * from "./confirm-error.vue?vue&type=script&lang=ts&setup=true"

import "./confirm-error.vue?vue&type=style&index=0&id=01d0b31e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d0b31e"]])

export default __exports__